/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's this about?`)
};

const es_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿De qué se trata?`)
};

const de_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worum geht es?`)
};

const nl_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar gaat het over?`)
};

const fr_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De quoi s'agit-il ?`)
};

const it_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di cosa si tratta?`)
};

const pt_br2_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o que é?`)
};

const pt_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o que é?`)
};

const ja_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご用件は何ですか？`)
};

const zh_contact_whats_this = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是关于什么的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_whats_this = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_whats_this(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_whats_this", locale)
	if (locale === "en") return en_contact_whats_this(inputs)
	if (locale === "es") return es_contact_whats_this(inputs)
	if (locale === "de") return de_contact_whats_this(inputs)
	if (locale === "nl") return nl_contact_whats_this(inputs)
	if (locale === "fr") return fr_contact_whats_this(inputs)
	if (locale === "it") return it_contact_whats_this(inputs)
	if (locale === "pt-BR") return pt_br2_contact_whats_this(inputs)
	if (locale === "pt") return pt_contact_whats_this(inputs)
	if (locale === "ja") return ja_contact_whats_this(inputs)
	return zh_contact_whats_this(inputs)
};